import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {Doughnut} from "react-chartjs-2";
import _ from "lodash";
import {CommandBarButton} from "office-ui-fabric-react";
import {
    AnyProcessorItemError, ProcessorItem,
    shortenProcessorItemErrorType
} from "../../models/MailroomProcessorItem";
import DispatchProps from "../../utils/DispatchProps";
import {IRootState} from "../../store";
import {DEFAULT_CHART_COLOURS} from "../pages/admin/workloads/WorkloadResultsCharts";


interface ProcessorErrorsChartsProps {
    processorItems?: ProcessorItem[];
    onCloseClicked(): void;
}

interface ProcessorErrorsChartsState {
    stepDoughnutData: any;
    fieldDoughnutData: any;
    typeDoughnutData: any;
}

class ProcessorErrorsCharts extends Component<ProcessorErrorsChartsProps & DispatchProps, ProcessorErrorsChartsState> {

    constructor(props: ProcessorErrorsChartsProps & DispatchProps) {
        super(props);

        this.state = {
            stepDoughnutData: {},
            fieldDoughnutData: {},
            typeDoughnutData: {},
        };
    }

    componentDidMount(): void {
        this.setChartData();
    }

    async componentDidUpdate(prevProps: Readonly<ProcessorErrorsChartsProps & DispatchProps>, prevState: Readonly<ProcessorErrorsChartsState>, snapshot?: any): Promise<void> {

        if(this.props.processorItems !== prevProps.processorItems)
        {
            this.setChartData();
        }
    }

    private setChartData() {

        if(!this.props.processorItems)
        {
            return;
        }
        
        const errors: {error: AnyProcessorItemError,itemType: string}[] = _.flatMap(this.props.processorItems!,(pi) => {
            return pi.errors.map((error: AnyProcessorItemError) => {
                return {itemType: pi.$type,error: error};
            })
        });
        
        
        const stepErrors = errors.filter(i => i.error.step);

        const errorsGroupedByStep = _.groupBy(stepErrors,i => i.error.step);
        const stepLabels = _.keys(errorsGroupedByStep).sort();
        const stepData = stepLabels.map(step => errorsGroupedByStep[step]?.length || 0);

        const stepDoughnutData = {
            labels: stepLabels,
            datasets: [{
                label: "Errors by step",
                data: stepData,
                backgroundColor: DEFAULT_CHART_COLOURS
            }]
        };

        const errorsGroupedByType = _.groupBy(errors,i => i.itemType);
        const types = _.keys(errorsGroupedByType).sort();
        const typeLabels = _.keys(errorsGroupedByType).sort().map(shortenProcessorItemErrorType);
        const typeData = types.map(type => errorsGroupedByType[type]?.length || 0);

        const typeDoughnutData = {
            labels: typeLabels,
            datasets: [{
                label: "Errors by item type",
                data: typeData,
                backgroundColor: DEFAULT_CHART_COLOURS
            }]
        };

        

        const fieldErrors = errors.filter(i => i.error.field);

        const errorsGroupedByField = _.groupBy(fieldErrors,i => i.error.field);
        const fieldLabels = _.keys(errorsGroupedByField).sort();
        const fieldData = fieldLabels.map(field => errorsGroupedByField[field]?.length || 0);

        const fieldDoughnutData = {
            labels: fieldLabels,
            datasets: [{
                label: "Errors by field",
                data: fieldData,
                backgroundColor: DEFAULT_CHART_COLOURS
            }]
        };
        

        this.setState({
            stepDoughnutData,
            typeDoughnutData,
            fieldDoughnutData
        });

    }

    render(): JSX.Element {
        return (
            <Fragment>
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Errors</span>
                        <CommandBarButton
                            iconProps={{iconName: "Cancel"}}
                            text="Close"
                            onClick={this.props.onCloseClicked}
                        />
                    </div>
                    <div className="card__content flex-column">
                        <div className={"flex-row flex--justify-content-space-around"}>
                            <div className="doughnut-holder">
                                <Doughnut data={this.state.typeDoughnutData} height={1} width={1} />
                            </div>
                            <div className="doughnut-holder">
                                <Doughnut data={this.state.stepDoughnutData} height={1} width={1} />
                            </div>
                            <div className="doughnut-holder">
                                <Doughnut data={this.state.fieldDoughnutData} height={1} width={1} />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { processorItems?: ProcessorItem[],onCloseClicked: () => void }): ProcessorErrorsChartsProps => {
        return {
            processorItems: ownProps.processorItems,
            onCloseClicked:ownProps.onCloseClicked
        };
    }
)(ProcessorErrorsCharts)